	export enum SalesPersonModeEnum {
		WsSalesPersons = 1,
		NetworkProviders = 2
	}
